module.exports=/[\0-\x1F\x7F-\x9F]/


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/uc.micro/categories/Cc/regex.js
// module id = C5Rt
// module chunks = 0